import React from "react";
import { withRouter } from 'react-router-dom';
import { Form, Col, Row, Card, Select, Spin, Button, Input, message } from "antd";
import { API, Auth, Storage } from "aws-amplify";
import { connect } from "react-redux";
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors";
import { CustomSpinner } from "../../Components/Spin/CustomSpiner";
import ReactPanZoom from 'react-image-pan-zoom-rotate'
// import FileViewer from 'react-file-viewer';

const { Option } = Select;

const statesDocuments = [
    {value: 'RECEIVED', name: 'Recibido'},
    {value: 'CLASSIFIED', name: 'Clasificado'},
    {value: 'CLASSIFICATION_ERROR', name: 'Sin Clasificar'},
    {value: 'EXTRACTED', name: 'Extraído'},
    {value: 'MANUAL_REVIEW', name: 'Revisión Manual'},
    {value: 'APPROVED', name: 'Aprobado'},
    {value: 'NOT_APPROVED', name: 'Desaprobado'},
    {value: 'VALIDATED', name: 'Validado'},
    {value: 'NOT_VALIDATED', name: 'No Validado'}
]

const componentMapping = {
    expiration_date: {key: 'expirationDate', label: 'Fecha de Control'},
    folio: {key: 'folio', label: 'Folio'},
    verification_code: {key: 'verificationCode', label: 'Código de Verificación'},
    resultado: {key: 'resultado', label: 'Resultado'},
    documento: {key: 'candidateNumberDoc', label: 'Documento Candidato'},
    observacion: {key: 'observacion', label: 'Observación'},
    apellido: {key: 'last_name', label: 'Apellidos'},
    nombre: {key: 'name', label: 'Nombres'},
    typeDocumentId: {key: 'typeDocumentId', label:''},
    typeDocumentName: {key: 'typeDocumentName', label: ''},
    stateDocument: {key: 'stateDocument', label: 'Estado'}
}

const onError = e => {
    console.log(e, "error in file-viewer");
};

class EditDocument extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading : true,
            document : {},
            candidate : {},
            documentTypes : [],
            documentTypeSelected : {},
            file : '',
            isPdf : true,
            statesDocuments: {},
            formElements: []
        };
    }

    componentDidMount() {
        this.setState({document: this.props.document}, () => {
            this.getCandidate()
            this.getDocumentView()
            this.getStateDocuments()
        });
    }

    async getDocumentView() {
        try {
            if (this.state.document.documentName) {
                this.setState({loading: true})
                let path = this.state.document.documentName.split("/");
                path.shift();
                path = path.join().replace(",", "/");
                const img = await Storage.get(path, { download: false })
                let isPdf = img.includes("pdf");
                this.setState({isPdf: isPdf, file : img, loading: false });
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    getDocumentTypes = () => {
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cdtypedocument/',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                this.setState({loading: false, documentTypes: response}, () => {
                    if (this.state.document.typeDocumentId && Object.keys(this.state.documentTypeSelected).length === 0){
                        let dtSelected = this.state.documentTypes.filter((e) => e.type_document_id === this.state.document.typeDocumentId);
                        this.setState({documentTypeSelected:dtSelected[0]}, () => {
                            this.configFormElements();
                        });
                    }
                })
            })
            .catch(err => console.log(err))
        })
    }

    getStateDocuments = () => {
       this.setState({statesDocuments: statesDocuments});
    }

    getCandidate = () => {
        Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]).then(([response, user]) => {
            API.get(
                'test',
                '/cd/cdcandidate/'+this.state.document.candidateId,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                this.setState({loading: false, candidate: response}, () => {
                    this.getDocumentTypes();
                })
            })
            .catch(err => console.log(err))
        });
    }

    updateTypeDocument(field, value) {
        let dtSelected = this.state.documentTypes.filter((e) => e.type_document_id === value);
        this.setState({documentTypeSelected:dtSelected[0]});
        this.updateData(field, value);
        this.updateData('typeDocumentName', dtSelected[0].name);
    }

    updateData(field, value) {
        let data = this.state.document;
        let dataCandidate = this.state.candidate;
        if ((field === 'apellido') || (field === 'nombre')){
            dataCandidate[componentMapping[field].key] = value;
        }else{
            data[componentMapping[field].key] = value;
        }
        this.setState({document: data, candidate: dataCandidate}, () => {
            this.configFormElements()
        });
    }

    save = () => {
        this.props.form.validateFields( { first: true }, (err, values) => {
            if (!err) {
               this.setState({ document: this.state.document, candidate: this.state.candidate, editting: false })
               this.send_data()
            }
        })
    }

    send_document_data = () => {
        this.setState({ loading: true })
        Auth.currentSession()
        .then(session => {
            const body = {...this.state.document}
            API.post(
                'test',
                '/cd/cddocument/',
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    body: body
                }
            )
            .then(response => {
                message.success("Documento actualizado")
                this.setState({ loading: false })
            })
            .catch(err => {
                message.error("Error al actualizar Documento")
                this.setState({ loading: false })
            })
        })
        .catch(err => {
            message.error("Error obteniendo credenciales de usuario")
            console.log(err)
        })
    }

    send_data = () => {
        this.setState({ loading: true })
        this.send_document_data()
        Auth.currentSession()
        .then(session => {
            const body = {
                candidate_id: this.state.candidate.candidate_id,
                name: this.state.candidate.name,
                last_name: this.state.candidate.last_name
            }
            API.put(
                'test',
                '/cd/cdcandidate/'+this.state.candidate.candidate_id,
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    body: body
                }
            )
            .then(response => {
                message.success("Candidato actualizado")
                this.setState({ loading: false })
            })
            .catch(err => {
                message.error("Error al actualizar Candidato")
                this.setState({ loading: false })
            })
        })
        .catch(err => {
            message.error("Error obteniendo credenciales de usuario")
            console.log(err)
        })
    }

    configFormElements(){
        let keyWords = (this.state.documentTypeSelected.key_words) ? JSON.parse(this.state.documentTypeSelected.key_words) : '';
        let document = (this.state.document !== undefined && this.state.document) ? this.state.document : null;
        let candidate = (this.state.candidate !== undefined && this.state.candidate) ? this.state.candidate : null;

        let elements = [];
        Object.keys(keyWords).map(function(key, index) {
            let newItem = {
                component: "input",
                label: key,
                required: true,
                value: (document[componentMapping[key].key]) ? document[componentMapping[key].key] : candidate[componentMapping[key].key]
            };
            elements.push(newItem);
        });

        elements.push({
            component: "input",
            label: 'observacion',
            required: false,
            value: (document[componentMapping['observacion'].key])
        });

        this.setState({formElements: elements});
    }

    render (){
        const {getFieldDecorator} = this.props.form;

        if (this.state.loading) {
            return (
                <>
                    <Row type="flex" justify="space-around" align="middle" style={{marginTop: '150px'}}>
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </>
            )
        } else {
            return(
                <Row gutter={[8, 12]} type="flex">
                    <Col lg={16} xs={24}>
                        <Card
                            title="Documento"
                            bodystyle={{ width: '100%', textAlign: 'center', height: '100%'}}>
                                {!this.state.isPdf && (
                                <div style={{width: '100%', overflow: 'scroll', height: '380px' }}>
                                    <ReactPanZoom
                                        objectFit="contain"
                                        image={this.state.file}
                                        alt='No se pudo cargar la imagen'
                                    />
                                </div>
                                )}
                                {this.state.isPdf && (
                                <div style={{ width: '100%', height: '380px' }}>
                                    {/* <FileViewer fileType="pdf" filePath={this.state.file} onError={onError} /> */}
                                </div>
                                )}
                        </Card>
                    </Col>

                    <Col lg={8} xs={24}>
                        <Card
                            title="Formulario"
                            bodystyle={{ width: '100%', height: '100%' }}>
                                <div style={{height: '380px', overflowY: 'scroll'}}>
                                    <Form>
                                        <Form.Item label="Tipo Documento" bodystyle={{ width: '100%', height: '380px'  }}>
                                        {
                                            getFieldDecorator('type_document_id', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Selecciona el Tipo de Documento'
                                                }],
                                                initialValue: this.state.document.typeDocumentId,
                                            })(
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Tipo Documento"
                                                    //disabled={(this.props.document.typeDocumentId) ? true : false}
                                                    onChange={(value) => this.updateTypeDocument("typeDocumentId", value)}>
                                                    {
                                                        this.state.documentTypes.map(value => {
                                                            return (<Option key={value.type_document_id}
                                                                value={value.type_document_id}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                        </Form.Item>
                                        <Form.Item label="Estado" bodystyle={{ width: '100%', height: '380px'  }}>
                                        {
                                            getFieldDecorator('state_document', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Selecciona el Estado'
                                                }],
                                                initialValue: this.state.document.stateDocument,
                                            })(
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Estado"
                                                    onChange={(value) => this.updateData("stateDocument", value)}>
                                                    {
                                                        this.state.statesDocuments.map(value => {
                                                            return (<Option key={value.value}
                                                                value={value.value}>{value.name}</Option>)
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                        </Form.Item>
                                        {this.state.formElements.map((component) => (
                                            <Col>
                                            <Form.Item label={componentMapping[component['label']].label}>
                                                {
                                                    getFieldDecorator(component['label'], {
                                                        rules: [{
                                                            required: component['required'],
                                                            message: componentMapping[component['label']].label+' es requerido'
                                                        }],
                                                        value: component['value'],
                                                        initialValue: component['value']
                                                    })(
                                                    <Input
                                                        value={component['value']}
                                                        onChange={(e) => this.updateData(component['label'], e.target.value ? e.target.value : null)}
                                                    />)
                                                }
                                            </Form.Item>
                                        </Col>
                                        ))}
                                    </Form>

                                    <Button
                                        style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                                        type={"primary"}
                                        icon="save"
                                        onClick={this.save}
                                    >Guardar</Button>
                                </div>
                        </Card>
                    </Col>
                </Row>
            )
        }
    }
}

const EditDocumentComponent = Form.create({ name: 'editDocument' })(EditDocument);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditDocumentComponent));